import React from 'react';
import { Card } from '../Card/Card.jsx';
import { Odometer } from '../Odometer/Odometer.jsx';
import { Stamp } from '../Stamp/Stamp.jsx';
import { BODY, TITLE } from '../../primitives.js';

const h = React.createElement;

/**
 * KPI tile: caps label, 28px tabular numeral, optional sub and a Stamp.
 *
 * @param {object} p
 * @param {boolean} [p.roll]
 * @param {React.ReactNode} p.label
 * @param {React.ReactNode} p.value
 * @param {React.ReactNode} [p.sub]
 * @param {'none'|'lime'|'gold'|'coral'|'paper'} [p.tint]
 * @param {React.ReactNode} [p.stamp]
 * @param {React.CSSProperties} [p.style]
 */
export function Stat({ label, value, sub, tint = 'none', stamp, style, roll = true }) {
  const shown = roll && (typeof value === 'string' || typeof value === 'number') && Odometer ? h(Odometer, { value }) : value;
  return h(Card, { tint, style: { position: 'relative', padding: '12px 14px', ...style } },
    stamp ? h(Stamp, { style: { position: 'absolute', top: -10, right: -6 } }, stamp) : null,
    h('div', { style: { fontFamily: BODY, fontSize: 10.5, fontWeight: 800, letterSpacing: '.1em', textTransform: 'uppercase', color: tint === 'none' ? 'var(--mut)' : 'var(--on-accent)', minHeight: 26 } }, label),
    h('div', { style: { fontFamily: TITLE, fontWeight: 800, fontSize: 'var(--type-kpi)', lineHeight: 1.05, letterSpacing: '-.02em', fontVariantNumeric: 'tabular-nums', marginTop: 4, color: tint === 'none' ? 'var(--tx)' : 'var(--on-accent)', overflowWrap: 'anywhere' } }, shown),
    sub ? h('div', { style: { fontSize: 11.5, marginTop: 3, color: tint === 'none' ? 'var(--mut2)' : 'var(--on-accent)', fontFamily: BODY } }, sub) : null);
}
